import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { createHead } from "@vueuse/head";
import { createI18n } from "vue-i18n";
import mitt from "mitt";
import VueProgressBar from "@aacassandra/vue3-progressbar";
import VueGtag from "vue-gtag";

require("./assets/normalize.css");
//require("./assets/nouislider.min.css");
require("./assets/style.css");

const barOptions = {
  color: "#a5a5a5",
  failedColor: "#874b4b",
  thickness: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};

fetch("/config.json")
  .then((res) => res.json())
  .then((config) => {
    const app = createApp(App);

    const head = createHead();
    // https://github.com/developit/mitt

    const emitter = mitt();

    app.config.globalProperties.$emitter = emitter;
    app.config.globalProperties.customConfig = config;

    window.extconfig = config;

    const i18n = createI18n({
      // something vue-i18n options here ...
      locale: "pl",
      messages: {
        en: require("./locales/en.json"),
        pl: require("./locales/pl.json"),
      },
    });

    app.config.globalProperties.$i18n = i18n;

    app
      .use(i18n)
      .use(router)
      .use(head)
      .use(emitter)
      .use(VueGtag, {
        config: { id: "G-VWJEVM46SM" },
      })
      .use(VueProgressBar, barOptions)
      .mount("#app");
  });
